import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'core/assets/icons/close.svg';

import Portal from '../portal';

import classes from './style.module.scss';

interface Props {
  children: any;
  position?: 'bottom';
  onClose: () => void;
  visible: boolean;
  showClose?: boolean;
  contentClassName?: string;
}

export const Modal = ({
  children,
  position = 'bottom',
  onClose,
  visible,
  showClose,
  contentClassName,
}: Props) => {
  const commonClassNames = { [classes.active]: visible, [classes[position]]: position };

  return (
    <Portal>
      <div className={classNames(classes.downsale, commonClassNames)}>
        <div className={classNames(classes.modal, commonClassNames, contentClassName)}>
          {showClose && <CloseIcon className={classes.close} onClick={onClose} />}
          {children}
        </div>
      </div>
    </Portal>
  );
};
